export default "__VITE_ASSET__a2b3f7c2__"